import { useAuthStore } from '@/stores/useAuthStore';

type Role = 'admin' | 'manager' | 'user';
type Roles = Role | Role[];

export const useRole = (roles: Roles): boolean => {
  const { user } = useAuthStore();

  if (!user) return false;

  if (typeof roles === 'string') {
    return roles === user.role;
  } else {
    return roles.some(role => role === user.role);
  }
};
